import React, { useEffect } from "react";
import Animation from "Components/Animation";
import mitekprogress from "Assets/Img/mitekprogress.json";
import { MITEK_TIMEOUTSECONDS } from 'Utils/EnvVars';
import "./mitek.scss";
const MitekInprogress = (props) => {
    const style = {
        width: '60%',
        height: '60%',
        overflow: 'hidden',
        border: 'none',
        textAlign: 'center'
    };

    useEffect(() => {
        (async () => {
            let responseMessage = await poll(10000);
            if (window.opener !== null && !window.opener.closed) {
                window.postMessage(responseMessage, "*");
            }
            else if (window.parent !== null && window.parent.frames !== null && window.parent.frames.length > 0) {
                window.parent.postMessage(responseMessage, "*");
            } else {
                if (/android/i.test(navigator.userAgent)) {
                    if (typeof window !== undefined) {
                        window.postMessage(responseMessage, "*");
                    } else if (document !== undefined) {
                        document.postMessage(responseMessage, "*");
                    }
                } else if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
                    window.postMessage(responseMessage, "*");
                }
            }
        })();
    }, []);

    const poll = async function (ms) {
        console.log("Entered Poll Method");
        let elapsedMilliSeconds = 0;
        console.log(MITEK_TIMEOUTSECONDS);
        const mitekTimeOutInMilliseconds = MITEK_TIMEOUTSECONDS * 1000;
        console.log(mitekTimeOutInMilliseconds);
        console.log("Elapsed Seconds before While Loop" + elapsedMilliSeconds);
        while (elapsedMilliSeconds < mitekTimeOutInMilliseconds) {
            await wait(ms);
            elapsedMilliSeconds = elapsedMilliSeconds + ms;
            console.log("Elapsed Seconds in While Loop" + elapsedMilliSeconds);
        }
        return "timeout";
    };

    const wait = function (ms = 5000) {
        return new Promise(resolve => {
            setTimeout(resolve, ms);
        });
    };

    const animProps = {
        animationData: mitekprogress,
        height: props.height,
        width: props.width,
        style: style,
        isLoop: true,
    };

    return (
        <>
            <div className="mitek-progress">
                <p>We are validating your submission.  Please wait.</p>
            </div>
            <Animation {...animProps} />
        </>
    );

};
MitekInprogress.defaultProps = { height: 200, width: 200 };
export default MitekInprogress;